
let defaultState = {
    focusedProject: null, // the integer id of whatever project we're working on
    projects: [],
    focusedLoanEstimate: {},
}

let projectLeads = (state = defaultState, action) => {

    switch (action.type) {

        case 'SET_PROJECTS':
            return {
                ...state,
                projects: []
            }

        case 'SET_FOCUSED_PROJECT':
            return {
                ...state,
                focusedProject: action.data
            }

        case 'SET_FOCUSED_LOAN_ESTIMATE':
            return {
                ...state,
                focusedLoanEstimate: action.data
            }
          
        default:
            return state
    }
}


export default projectLeads;
